import { func } from "prop-types";
import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getBusinessList, chartResponse, postCollectData, postMyContract, tradeHistoryCall, getBusinessCompany, getAllbaroData, totalTradeHistoryCall, multiTradeHistoryCall, chartTotalResponse, chartMultiResponse, postMultiMyContract, postTotalMyContract } from "crud/auth.crud";

import _ from "lodash";
import moment from "moment";
import Util from "pages/Dashboard/Common/Util";
import ChartistGraph from 'react-chartist';
import Modal from "components/RopikCustom/Modal";

// import images
import weaver from "../../assets/images/weaver.png";
import loading from "../../assets/images/loading.gif";
import Default from "assets/images/default.png";
import Loading from "pages/Custom/Loading";

const BusinessList = () => {
  const history = useHistory()
  const selector = useSelector(state => state)
  const newDate = new Date()
  const nextDate = new Date()

  const [dataList, setDataList] = useState([]);
  const [detailType, setDetailType] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0]?.type || "")
  const [historyList, setHistoryList] = useState([]);
  const [allbaroList, setAllbaroList] = useState([]);
  const [sumList, setSumList] = useState([]);
  const [totalSum, setTotalSum] = useState(0);
  const [company, setCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.id);
  const [startDate, setStartDate] = useState(moment(newDate).format('YYYY-MM') + '-01 00:00:00');
  const [endDate, setEndDate] = useState(moment(nextDate.setMonth(nextDate.getMonth()+1)).format('YYYY-MM') + '-01 00:00:00');
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [isLoading3, setIsLoading3] = useState(false);
  const [isLoading4, setIsLoading4] = useState(false);
  const [isClick, setIsClick] = useState();
  const [findingState, setFindingState] = useState('year')
  const [tableValue, setTableValue] = useState([]);
  const [tableValue2, setTableValue2] = useState([]);
  const [chartValue, setChartValue] = useState([]);
  const [chartValue2, setChartValue2] = useState([]);
  const [letDate, setLetDate] = useState(newDate)
  const [form, setForm] = useState('chart')
  const [newMonth, setNewMonth] = useState('');
  const [year, setYear] = useState(parseInt(moment(newDate).format("YYYY")) + '');
  const [pricePerL, setPricePerL] = useState(100);
  const [priceList, setPriceList] = useState([]);
  const [page1, setPage1] = useState(1);
  const [pagesGroup1, setPagesGroup1] = useState(1)
  const [pageArr1, setPageArr1] = useState([pagesGroup1, pagesGroup1 + 1, pagesGroup1 + 2, pagesGroup1 + 3, pagesGroup1 + 4])
  const [contentCount1, setContentCount1] = useState()
  const [page2, setPage2] = useState(1);
  const [pagesGroup2, setPagesGroup2] = useState(1)
  const [pageArr2, setPageArr2] = useState([pagesGroup2, pagesGroup2 + 1, pagesGroup2 + 2, pagesGroup2 + 3, pagesGroup2 + 4])
  const [contentCount2, setContentCount2] = useState()
  const [childCompany, setChildCompany] = useState()
  const [dataType, setDataType] = useState('')
  const [dataCompany, setDataCompany] = useState('')
  const [selectedItem, setSelectedItem] = useState({})
  const [modalShow, setModalShow] = useState(false)

  const dayData = ['일', '월', '화', '수', '목', '금', '토']

  const lineChartData = findingState === 'year' ? 
  {
    labels: [...chartValue.map(item => item.month)],
    series: [
      chartValue.map((item) => {
        return (item.sum)
      })
    ],
  }
  :
  {
    labels: [...chartValue2.map(item => item.x)],
    series: [
      chartValue2.map((item) => {
        return (item.y)
      })
    ],
  }
  const lineChartOptions = {
    low: 0,
    showArea: true,
  }

  const getChartList = async (companyId) => {
    setIsLoading2(true)
    let date = new Date()
    let yearDate = new Date()

    let params = {
      company: companyId,
      start_ym: moment(yearDate.setFullYear(yearDate.getFullYear() - 1)).format("YYYY-MM") + '-01',
      end_ym: moment(date.setMonth(date.getMonth() + 1)).format('YYYY-MM') + '-01',
    }

    let response
    if(isClick === 'entire' && detailType === 'total'){
      response = await chartTotalResponse(params)
    }else if(isClick === 'entire' && detailType === 'multi'){
      response = await chartMultiResponse(params)
    }else{
      response = await chartResponse(params)
    }
    const content = response.data?.data || [];
    let tmpArr = []
    let tmpMonth = []
    let tmpDate = '';

    for (let i = 0; i < 12; i++) {
      tmpDate = moment(date.setMonth(date.getMonth() - 1)).format('YYYY-MM')
      tmpMonth.push(moment(date).format('MM') + '월')
      tmpArr.push(tmpDate)
    }

    let tempArr = []
    let chartArr = []
    let tmpArr2 = [0, 0, 0, 0, 0, 0, 0]
    let prevTmpArr2 = [0, 0, 0, 0, 0, 0, 0]
    for (let i = 0; i < tmpArr.length; i++) {
      let tmpSum = 0;
      for (let j = 0; j < content.length; j++) {
        const data = content[j];
        if(tmpArr[i] === moment(new Date(data.month)).format('YYYY-MM')){
          tmpSum = data.total;                    
        }
      }
      let item = {
        date: tmpArr[i],
        month: tmpMonth[i],
        sum: tmpSum,
        bar: tmpSum.toString().length > 2 ? tmpSum / 10 ** ((tmpSum.toString().length - 2)) * 2 : tmpSum * 2,
        x: tmpMonth[i],
        y: tmpSum,
      }
      let items = [
        tmpArr[i],
        tmpSum,
      ]
      tempArr.push(items)
      chartArr.push(item)
    }

    for (let i = 0; i < tempArr.length; i++) {
      let val = tempArr[i]
      let tmpDiff = val[1] - (tempArr[i + 1]?.[1] || 0)
      val.push(tmpDiff)
      val.push(parseInt(val[1] * 0.01))
    }
    tempArr = tempArr.filter(itm => itm[0] + '-01' !== params.start_ym)
    chartArr = chartArr.filter(itm => itm.date + '-01' !== params.start_ym)
    chartArr.reverse()

    let tempArr2 = []
    let chartArr2 = []
    let weekData = response.data?.week || [];
    let prevWeekData = response.data?.prev_week || [];
    for (let i = 0; i < tmpArr2.length; i++) {
      let val = weekData.filter(itm => itm.day - 1 === i)?.[0]
      tmpArr2[i] = val?.qty_sum || 0
      let prev_val = prevWeekData.filter(itm => itm.day - 1 === i)?.[0]
      prevTmpArr2[i] = prev_val?.qty_sum || 0
      let items = [
        dayData[i],
        tmpArr2[i],
        tmpArr2[i] - prevTmpArr2[i],
        parseInt(tmpArr2[i] * 0.15),
      ]
      tempArr2.push(items)
      let itm = {
        x: dayData[i],
        y: tmpArr2[i]
      }
      chartArr2.push(itm)
    }

    setChartValue(chartArr)
    setChartValue2(chartArr2)
    setTableValue(tempArr)
    setTableValue2(tempArr2)
    setIsLoading2(false)
  }

  const getMyContract = async (params) => {
    try {
      let tmp = []
      const response = await postMyContract({ids : params.ids})
      if (response.data?.result === 'success') {
        const dataList = response?.data?.data
        for(let i = 0; i < dataList.length; i++){
          tmp.push({
            companyId: dataList[i].contract_company_group_data.id,
            companyName: dataList[i].contract_company_group_data.name,
            minPrice: dataList[i].contract_group_data.min_price,
            pricePerL: dataList[i].contract_group_data.price_per_l,
          })
        }
      }
      setPriceList(tmp)
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false)
  }

  const getCollectDataSum = async (dataList) => {
    try {
      let tmp = []
      for (let i = 0; i < dataList.length; i++) {
        tmp.push(dataList[i].id)
      }
      const params = {
        ids: JSON.stringify(tmp),
        start_ym: startDate,
        end_ym: endDate,
      }
      const response = await postCollectData(params);
      if (response.data?.result === 'success') {
        const dataList = response?.data?.data;
        let sum = 0
        for (let i = 0; i < dataList.length; i++) {
          sum = sum + (dataList[i].sum || 0);
        }
        setTotalSum(sum)
        setSumList(dataList)
      }
      getMyContract(params)
    } catch (error) {
      console.error(error);
    }
  }

  const getDataList = async () => {
    setIsLoading(true)
    try {
      const response = await (detailType === 'multi' ? getBusinessList(`?id=${company}`) : getBusinessCompany(company));
      if (response.data?.result === 'success') {
        let dataList = response?.data?.data?.filter(itm => itm.id !== company);
        let myData = response?.data?.data?.filter(itm => itm.id === company);
        setDataList([...myData, ...dataList])
        getCollectDataSum([...myData, ...dataList])
      }
    } catch (error) {
      console.error(error);
    }
  }

  // 드롭다운 map용
  const yearSelect = [
    moment(newDate).format("YYYY") - 3, moment(newDate).format("YYYY") - 2, moment(newDate).format("YYYY") - 1, moment(newDate).format("YYYY")
  ]
  const monthSelect = [
    ...Array(12).keys()
  ].map(x => x + 1)

  const handleYearClick = (e) => {
    setYear(e.target.value)
    setHistoryList([])
    setNewMonth('')
    setPage1(1)
    setPagesGroup1(1)
  }

  const handleMonthClick = (e) => {
    setNewMonth(e.target.value)
    setHistoryList([])
    setPage1(1)
    setPagesGroup1(1)
  }

  const nextGetData1 = async () => {
    let newArr = []
    for (let i = pagesGroup1 - 1; i < pagesGroup1 + 4; i++) {
      if (i + 1 <= contentCount1) {
        newArr.push(i + 1)
      }
    }
    setPageArr1(newArr)
  }

  const nextGetData2 = async () => {
    let newArr = []
    for (let i = pagesGroup2 - 1; i < pagesGroup2 + 4; i++) {
      if (i + 1 <= contentCount2) {
        newArr.push(i + 1)
      }
    }
    setPageArr2(newArr)
  }

  const getHistoryList = async (companyId) => {
    setIsLoading3(true)
    let month = newMonth < 10 ? '0' + newMonth : newMonth;
    let start_ym = newMonth ? year + '-' + month + '-01' : year + '-01-01';
    let newDate = new Date(start_ym)
    let end_ym = newMonth ? moment(newDate.setMonth(newDate.getMonth() + 1)).format("YYYY-MM") + '-01' : (parseInt(year) + 1) + '-01-01';
    const params = {
      company: companyId,
      start_ym,
      end_ym,
      page: page1
    }
    let response
    if(isClick === 'entire' && detailType === 'total'){
      response = await totalTradeHistoryCall(params)
    }else if(isClick === 'entire' && detailType === 'multi'){
      response = await multiTradeHistoryCall(params)
    }else{
      response = await tradeHistoryCall(params)
    }
    let dataCount = response.data.count % 15 === 0 ? response.data.count / 15 : Math.floor(response.data.count / 15) + 1
    if (!contentCount1 || contentCount1 !== dataCount) {
      if(dataCount === 0){
        setContentCount1(1)
      }else{
        setContentCount1(dataCount)
      }
      let newArr = []
      for (let i = pagesGroup1 - 1; i < pagesGroup1 + 4; i++) {
        if (i + 1 <= dataCount) {
          newArr.push(i + 1)
        }
      }
      if(newArr.length === 0) newArr = [1]
      setPageArr1(newArr)
    }
    const content = response.data?.results || []
    if (content.length > 0) {
      setHistoryList([...content])
    } else {
      setHistoryList([])
    }
    setIsLoading3(false)
  }

  const getAllbaroList = async (companyId) => {
    setIsLoading4(true)
    const params = {
      page: page2,
      company: companyId
    }

    const response = await getAllbaroData(params);
    let dataCount = response.data.count % 15 === 0 ? response.data.count / 15 : Math.floor(response.data.count / 15) + 1
    if (!contentCount2 || contentCount2 !== dataCount) {
      if(dataCount === 0){
        setContentCount2(1)
      }else{
        setContentCount2(dataCount)
      }
      let newArr = []
      for (let i = pagesGroup2 - 1; i < pagesGroup2 + 4; i++) {
        if (i + 1 <= dataCount) {
          newArr.push(i + 1)
        }
      }
      if(newArr.length === 0) newArr = [1]
      setPageArr2(newArr)
    }
    if (typeof (response.data.count) === 'undefined') {
      setPageArr2([1])
      setContentCount2(1)
    }
    if (response.status === 200) {
      const content = response.data?.data || [];
      if (content.length > 0) {
        setAllbaroList([...content])
      } else {
        setAllbaroList([])
      }
    }
    setIsLoading4(false)
  }

  const modalClose = () => {
    setModalShow(false);
  }

  useEffect(() => {
    getDataList()
  }, [])

  useEffect(() => {
    nextGetData1()
  }, [pagesGroup1])

  useEffect(() => {
    nextGetData2()
  }, [pagesGroup2])

  useEffect(()=>{
    if((isClick !== 1 && isClick !== 'entire') && form === 'allbaro'){
      setForm('history')
    }
    getChartList(dataCompany)
    getHistoryList(dataCompany)
    detailType === 'total' && getAllbaroList()
  }, [isClick])

  useEffect(()=>{
    getHistoryList(dataCompany)
  }, [page1, year, newMonth])

  useEffect(()=>{
    getAllbaroList(dataCompany)
  }, [page2])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>사업장 리스트 | 웨이스트버스</title>
        </MetaTags>
        <div className="account-pages">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs maintitle="Home" breadcrumbItem="관리대장" />

            <Row>
              <Col md={12} lg={4} xl={3} style={{minWidth: !isClick && '32rem'}}>
                <Card className="overflow-hidden">
                  <CardBody className="p-4">
                    <p className="mb-0 text-gray font-size-14">열람하실 사업장을 선택해주세요</p>
                    <div className="mt-4">

                      <div className="pointer card-list"
                        onClick={() => {
                          setPage1(1)
                          setPage2(1)
                          setPagesGroup1(1)
                          setPagesGroup2(1)
                          setDataCompany(company)
                          isClick === 'entire' ? setIsClick() : setIsClick('entire')
                        }}>
                        <div>
                          <p className="font-size-20 text-black font-weight-bold mb-0">{'전체'}</p>
                        </div>
                        <div>
                          <p className="font-size-20 text-black font-weight-bold mb-0 d-flex">
                            <span className="text-secondary">{Util.setPrice(totalSum)}</span>&nbsp;L&emsp;
                            <span style={{ transform: 'rotate(90deg)' }}>
                              <i className={`mdi ${isClick === 'entire' ? 'mdi-triangle' : 'mdi-triangle-outline'} text-silver`} />
                            </span>
                          </p>
                        </div>
                      </div>

                      {dataList && dataList.map((item, index) => {
                        const sum = sumList.filter(itm => itm.id === item.id)?.[0]?.sum || 0;
                        return (
                          <div key={index} className="pointer card-list"
                            onClick={() => {
                              setPage1(1)
                              setPage2(1)
                              setPagesGroup1(1)
                              setPagesGroup2(1)
                              setDataCompany(item.id)
                              isClick - 1 === index ? setIsClick() : setIsClick(index + 1)
                            }}>
                            <div>
                              <p className="font-size-20 text-black font-weight-bold mb-0">{item.name}</p>
                            </div>
                            <div>
                              <p className="font-size-20 text-black font-weight-bold mb-0 d-flex">
                                <span className="text-secondary">{Util.setPrice(sum)}</span>&nbsp;L&emsp;
                                <span style={{ transform: 'rotate(90deg)' }}>
                                  <i className={`mdi ${isClick - 1 === index ? 'mdi-triangle' : 'mdi-triangle-outline'} text-silver`} />
                                </span>
                              </p>
                            </div>
                          </div>
                        )
                      })}

                    </div>
                  </CardBody>
                  {isLoading && <Loading />}
                </Card>
              </Col>
              {isClick && form === 'chart' &&
                <Col md={12} lg={8} xl={9}>

                  <div className="btn-group" style={{ margin: "0 auto 1.5rem", height: 38 }}>
                    <Button
                      type="button"
                      size="sm"
                      className={`${form == 'chart' ? 'active' : ''} waves-effect custom-btn`}
                      onClick={() => {
                        setForm('chart')
                      }}
                    >
                      차트
                    </Button>
                    <Button
                      type="button"
                      size="sm"
                      className={`${form == 'history' ? 'active' : ''} waves-effect custom-btn`}
                      onClick={() => {
                        setForm('history')
                      }}
                    >
                      수거내역
                    </Button>
                    {(isClick === 1 || isClick === 'entire') && detailType === 'total' &&
                    <Button
                      type="button"
                      size="sm"
                      className={`${form == 'allbaro' ? 'active' : ''} waves-effect custom-btn`}
                      onClick={() => {
                        setForm('allbaro')
                      }}
                    >
                      올바로
                    </Button>
                    }
                  </div>

                  <Card>
                    <div className="btn-group btn-group-sm justify-content-end" style={{ margin: "1.5rem" }}>
                      <button
                        type="button"
                        className={`${findingState == 'year' ? 'active' : ''} left-btn regist-btn`}
                        onClick={() => {
                          setFindingState('year')
                        }}
                      >
                        월별 배출량 차트
                      </button>
                      <button
                        type="button"
                        className={`${findingState == 'month' ? 'active' : ''} right-btn regist-btn`}
                        onClick={() => {
                          setFindingState('month')
                        }}
                      >
                        요일별 배출량 차트
                      </button>
                    </div>
                    <CardBody>
                      <Row style={{ borderRadius: '4px' }}>
                        <Col lg={12} style={{ margin: "24px auto" }}>
                          <div>
                            <ChartistGraph data={lineChartData} style={{ height: "300px" }} options={lineChartOptions} type={'Bar'} />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    {isLoading2 && <Loading />}
                  </Card>

                  <Card style={{ borderRadius: '4px', overflow: 'hidden' }}>
                    <CardBody style={{ padding: 0 }}>
                      <Row style={{ margin: 0 }}>
                        <table className='chart-table'>
                          <thead className='chart-thead'>
                            <tr>
                              <td>{findingState === 'year' ? '년/월' : '요일'}</td>
                              <td>배출량(kg)</td>
                              <td>증감</td>
                              <td>CO₂배출량</td>
                            </tr>
                          </thead>
                          <tbody className='chart-tbody'>
                            {findingState === 'year' && tableValue.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item[0]}</td>
                                  <td>{Util.setPrice(item[1])}</td>
                                  <td style={{ color: item[2] < 0 ? 'red' : 'blue' }}>{item[2] <= 0 ? Util.setPrice(item[2]) : '+' + Util.setPrice(item[2])}</td>
                                  <td >{Util.setPrice(item[3])}</td>
                                </tr>
                              )
                            })}
                            {findingState === 'month' && tableValue2.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item[0]}</td>
                                  <td>{Util.setPrice(item[1])}</td>
                                  <td style={{ color: item[2] < 0 ? 'red' : 'blue' }}>{item[2] <= 0 ? Util.setPrice(item[2]) : '+' + Util.setPrice(item[2])}</td>
                                  <td >{Util.setPrice(item[3])}</td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </Row>
                    </CardBody>
                    {isLoading2 && <Loading />}
                  </Card>

                </Col>
              }

              {isClick && form === 'history' &&
                <Col md={12} lg={8} xl={9}>

                  <div className="d-flex justify-content-between">
                    <div className="btn-group" style={{ margin: "0 auto 1.5rem 0", height: 38 }}>
                      <Button
                        type="button"
                        size="sm"
                        className={`${form == 'chart' ? 'active' : ''} waves-effect custom-btn`}
                        onClick={() => {
                          setForm('chart')
                        }}
                      >
                        차트
                      </Button>
                      <Button
                        type="button"
                        size="sm"
                        className={`${form == 'history' ? 'active' : ''} waves-effect custom-btn`}
                        onClick={() => {
                          setForm('history')
                        }}
                      >
                        수거내역
                      </Button>
                      {(isClick === 1 || isClick === 'entire') && detailType === 'total' &&
                      <Button
                        type="button"
                        size="sm"
                        className={`${form == 'allbaro' ? 'active' : ''} waves-effect custom-btn`}
                        onClick={() => {
                          setForm('allbaro')
                        }}
                      >
                        올바로
                      </Button>
                      }
                    </div>

                    <div>
                      <select id="yearselect" name="yearselect" className='dropdown-toggle waves-effect waves-light mb-4 waver-select-box' value={year} onChange={(e) => {
                        handleYearClick(e)
                      }}>
                        {yearSelect && yearSelect.map((item, index) => {
                          return (
                            <option key={index} value={item}>{item + "년"}</option>
                          )
                        })}
                      </select>
                      <select id="monthselect" name="monthselect" className='dropdown-toggle waves-effect waves-light waver-select-box' style={{ marginLeft: 16 }} value={newMonth} onChange={(e) => {
                        handleMonthClick(e)
                      }}>
                        <option value={''}>전체</option>
                        {monthSelect && monthSelect.map((item, index) => {
                          return (
                            <option key={index} value={item}>{item + "월"}</option>
                          )
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="email-rightbar mb-3">
                    <Card>
                      <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                        <div className="table-responsive">
                          <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                            <thead className="chart-thead">
                              <tr>
                                <th scope="col">ID</th>
                                <th scope="col">수거업체명</th>
                                <th scope="col">차량번호</th>
                                <th scope="col">쓰레기통</th>
                                <th scope="col">수거일자</th>
                                <th scope="col">정산금액(원)</th>
                                <th scope="col">수거량(L)</th>
                              </tr>
                            </thead>
                            <tbody className="chart-tbody">
                              {historyList && historyList.map((item, index) => {
                                return (
                                  <tr className="pointer" key={item.id + '_' + index} onClick={()=>{
                                    setSelectedItem(item)
                                    setModalShow(true)
                                  }}>
                                    <td>{item.id}</td>
                                    <td>{item.driver_company_data?.name}</td>
                                    <td>{item.car_data?.number || '차량번호없음'}</td>
                                    <td>{item.state === 'N' ? item.memo : item.rf_id}</td>
                                    <td>{item.created_at.substr(0, 10)}</td>
                                    <td>{Util.setCommaPrice(item.qty * priceList.filter(itm => itm.companyId === item.company)[0]?.pricePerL)}</td>
                                    <td>{item.state === 'N' ? '미수거' : Util.setCommaPrice(item.qty)}</td>
                                  </tr>
                                )
                              })
                              }
                              {historyList.length === 0 &&
                                <tr >
                                  <td scope="row" colSpan="7">데이터가 없습니다.</td>
                                </tr>
                              }

                            </tbody>
                          </table>
                        </div>
                      </CardBody>
                      {isLoading3 && <Loading />}
                    </Card>
                    <Row>
                      <Col xs="12" style={{ textAlign: "center" }}>
                        <div className="btn-group mt-4 waver-pagination-btn-group">
                          <Button
                            type="button"
                            size="sm"
                            className={`${page1 !== 1 ? 'active' : ''} waves-effect left-btn btn-page`}
                            onClick={() => {
                              if (page1 !== 1 && !isLoading3) {
                                setPage1(page1 - 1)
                                if (Math.min(...pageArr1) === page1) {
                                  setPagesGroup1(pagesGroup1 - 5)
                                }
                              }
                            }}
                          >
                            <i className="fa fa-chevron-left" />
                          </Button>
                          {pageArr1 && pageArr1.map((item, index) => {
                            return (
                              <Button
                                key={index}
                                type="button"
                                size="sm"
                                className={`${page1 === item ? 'active' : ''} waves-effect center-btn btn-page`}
                                onClick={() => {
                                  !isLoading3 && setPage1(item)
                                }}
                              >
                                {item}
                              </Button>
                            )
                          })}
                          <Button
                            type="button"
                            size="sm"
                            className={`${page1 !== contentCount1 ? 'active' : ''} waves-effect right-btn btn-page`}
                            onClick={() => {
                              if (page1 !== contentCount1 && !isLoading3) {
                                setPage1(page1 + 1)
                                if (Math.max(...pageArr1) === page1) {
                                  setPagesGroup1(pagesGroup1 + 5)
                                }
                              }
                            }}
                          >
                            <i className="fa fa-chevron-right" />
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              }

              {(isClick === 1 || isClick === 'entire') && form === 'allbaro' &&
                <Col md={12} lg={8} xl={9}>

                  <div className="d-flex justify-content-between">
                    <div className="btn-group" style={{ margin: "0 auto 1.5rem 0", height: 38 }}>
                      <Button
                        type="button"
                        size="sm"
                        className={`${form == 'chart' ? 'active' : ''} waves-effect custom-btn`}
                        onClick={() => {
                          setForm('chart')
                        }}
                      >
                        차트
                      </Button>
                      <Button
                        type="button"
                        size="sm"
                        className={`${form == 'history' ? 'active' : ''} waves-effect custom-btn`}
                        onClick={() => {
                          setForm('history')
                        }}
                      >
                        수거내역
                      </Button>
                      <Button
                        type="button"
                        size="sm"
                        className={`${form == 'allbaro' ? 'active' : ''} waves-effect custom-btn`}
                        onClick={() => {
                          setForm('allbaro')
                        }}
                      >
                        올바로
                      </Button>
                    </div>
                  </div>

                  <div className="email-rightbar mb-3">
                    <Card>
                      <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                        <div className="table-responsive">
                          <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                            <thead className="chart-thead">
                              <tr>
                                <th scope="col" >ID</th>
                                <th scope="col" >거래처명</th>
                                <th scope="col" >거래일자</th>
                                <th scope="col" >배출량(L)</th>
                                <th scope="col" >정산금액(원)</th>
                                <th scope="col" >정산여부</th>
                              </tr>
                            </thead>
                            <tbody className="chart-tbody">
                              {allbaroList && allbaroList.map((item, index) => {
                                return (
                                  <tr key={item.id + '_' + index}>
                                    <td scope="row">{item.id}</td>
                                    <td>{item.company?.name}</td>
                                    <td>{item.created_at.substr(0, 10)}</td>
                                    <td>{item.qty}</td>
                                    <td>{Util.setCommaPrice(item.qty * priceList.filter(itm => itm.companyId === item.company)[0]?.pricePerL)}</td>
                                    <td>{"미정산"}</td>
                                  </tr>
                                )
                              })
                              }
                              {allbaroList.length === 0 &&
                                <tr >
                                  <td scope="row" colSpan="6">데이터가 없습니다.</td>
                                </tr>
                              }

                            </tbody>
                          </table>
                        </div>
                      </CardBody>
                      {isLoading4 && <Loading />}
                    </Card>
                    <Row>
                      <Col xs="12" style={{ textAlign: "center" }}>
                        <div className="btn-group mt-4 waver-pagination-btn-group">
                          <Button
                            type="button"
                            size="sm"
                            className={`${page2 !== 1 ? 'active' : ''} waves-effect left-btn btn-page`}
                            onClick={() => {
                              if (page2 !== 1 && !isLoading4) {
                                setPage2(page2 - 1)
                                if (Math.min(...pageArr2) === page2) {
                                  setPagesGroup2(pagesGroup2 - 5)
                                }
                              }
                            }}
                          >
                            <i className="fa fa-chevron-left" />
                          </Button>
                          {pageArr2 && pageArr2.map((item, index) => {
                            return (
                              <Button
                                key={index}
                                type="button"
                                size="sm"
                                className={`${page2 === item ? 'active' : ''} waves-effect center-btn btn-page`}
                                onClick={() => {
                                  !isLoading4 && setPage2(item)
                                }}
                              >
                                {item}
                              </Button>
                            )
                          })}
                          <Button
                            type="button"
                            size="sm"
                            className={`${page2 !== contentCount2 ? 'active' : ''} waves-effect right-btn btn-page`}
                            onClick={() => {
                              if (page2 !== contentCount2 && !isLoading4) {
                                setPage2(page2 + 1)
                                if (Math.max(...pageArr2) === page2) {
                                  setPagesGroup2(pagesGroup2 + 5)
                                }
                              }
                            }}
                          >
                            <i className="fa fa-chevron-right" />
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              }

            </Row>
            <Modal title={'상세보기'} show={modalShow} onHide={modalClose} size="md">
              <div style={{ zIndex: 1, minHeight : '300px', width: '100%', display: "flex", justifyContent: "center", flexDirection: 'column' }}>
                <p style={{fontSize: '1rem', textAlign: 'center'}}>{selectedItem.name}</p>
                <img style={{
                  margin: '0 auto',
                  width: 382,
                }}
                src={ Util.addHostUrl(selectedItem?.waste_collect_file?.[0]?.path) }
                onError={(e) => e.target.src = Default} />
              </div>
            </Modal>

          </Container>
        </div>
      </div>

    </React.Fragment>
  )
}

export default BusinessList
